export default __webpack_public_path__ + "static/media/document_icon.d45cdc8e.svg";